import React from 'react';
import SharedDialogSelectorContext from './SharedDialogSelectorContext';

export default function useSharedDialog()
{
  return React.useContext(SharedDialogSelectorContext);
}